import { render, staticRenderFns } from "./NewsDescriptionPage.vue?vue&type=template&id=80619ab4&scoped=true&"
import script from "./NewsDescriptionPage.vue?vue&type=script&lang=js&"
export * from "./NewsDescriptionPage.vue?vue&type=script&lang=js&"
import style0 from "./NewsDescriptionPage.vue?vue&type=style&index=0&id=80619ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80619ab4",
  null
  
)

export default component.exports